import { CapacitorBarcodeScanner, CapacitorBarcodeScannerTypeHint } from '@capacitor/barcode-scanner';
import { BARCODE_SCANNER } from '@/utils/constants.ts';

export class QrScannerService {
    static async scan(): Promise<string | null | typeof BARCODE_SCANNER.INTERNAL.CANCELLED> {
        try {
            const result = await CapacitorBarcodeScanner.scanBarcode({
                hint: CapacitorBarcodeScannerTypeHint.QR_CODE,
            });

            if (!result?.ScanResult) return BARCODE_SCANNER.INTERNAL.CANCELLED;
            return result.ScanResult;

        } catch (error: any) {
            if (error?.code === BARCODE_SCANNER.CODES.USER_CANCELLED) return BARCODE_SCANNER.INTERNAL.CANCELLED;
            console.error('Hardware Scan Error:', error);
            return null;
        }
    }
}